/* MONOM, modulo di iscrizione.

   Tre regole che il popup di prima non rispettava:
   1. non si apre finche' c'e' il banner dei cookie, che prima gli finiva sopra
      e copriva proprio il campo dell'email;
   2. non si apre subito: aspetta che la persona abbia guardato qualcosa;
   3. chi si e' iscritto, o ha chiuso, non lo rivede per un pezzo.

   L'iscrizione va a Omnisend con la sua API JS, la stessa che usa il modulo
   dell'app: cosi' l'automazione che manda il codice del 10% parte come prima.
*/
(function () {
  var CHIAVE = 'monom-popup';
  /* Prima aspettava 14 secondi su qualunque pagina: chi arrivava da un annuncio
     se lo trovava davanti mentre guardava il profumo (8 ottobre: un terzo delle
     visite da Meta lo chiudeva). Ora alla prima pagina della visita aspetta 40
     secondi; dalla seconda pagina in poi 20 secondi (Raffaello, 8/10: con 8 secondi
     si apriva quasi subito). */
  var ATTESA = (function () {
    var n = 1;
    try {
      n = parseInt(sessionStorage.getItem('monom-pagine') || '0', 10) + 1;
      sessionStorage.setItem('monom-pagine', String(n));
    } catch (e) { /* in navigazione privata vale la prima pagina */ }
    return n >= 2 ? 20000 : 40000;
  })();
  /* Raffaello, 15/10: il popup non si apre piu' da solo. Resta la linguetta,
     che ogni 15 secondi si muove un attimo per farsi notare. */
  var APERTURA_AUTOMATICA = false;
  var GIORNI_CHIUSO = 14;      /* se lo chiudi, torna fra due settimane */
  var GIORNI_ISCRITTO = 3650;  /* se ti iscrivi, non torna piu' */

  function stato() {
    try { return JSON.parse(localStorage.getItem(CHIAVE) || '{}'); }
    catch (e) { return {}; }
  }
  function segna(cosa, giorni) {
    try {
      localStorage.setItem(CHIAVE, JSON.stringify(
        {cosa: cosa, fino: Date.now() + giorni * 86400000}));
    } catch (e) { /* in navigazione privata non si puo': pazienza */ }
  }
  function giaVisto() {
    var s = stato();
    return !!(s.fino && s.fino > Date.now());
  }

  /* Il banner dei cookie (Consentmo) sta sopra tutto: finche' e' li', il popup
     resta chiuso, se no si coprono a vicenda. */
  function cookieAperti() {
    /* Il banner dei cookie ora e' quello nativo di Shopify (prima era
       Consentmo, disinstallato il 2 ottobre perche' faceva 19 richieste per
       mostrare un riquadro). Si cerca il suo riquadro, e in seconda battuta
       si chiede chi c'e' in cima in fondo allo schermo, dove il banner si
       appoggia: cosi' la verifica regge anche se domani cambia di nuovo. */
    var suo = document.querySelector('.shopify-pc__banner, .shopify-pc__banner__dialog, #shopify-pc__banner');
    if (suo) {
      var r = suo.getBoundingClientRect();
      var s = getComputedStyle(suo);
      if (r.height > 60 && s.display !== 'none' && s.visibility !== 'hidden') return true;
    }
    var punti = [
      [window.innerWidth / 2, window.innerHeight - 30],
      [window.innerWidth / 2, window.innerHeight - 120]
    ];
    for (var i = 0; i < punti.length; i++) {
      var e = document.elementFromPoint(punti[i][0], punti[i][1]);
      while (e) {
        var nome = (e.tagName || '').toLowerCase();
        var cl = (e.className || '').toString();
        if (nome === 'csm-cookie-consent' || /csm-cmp|shopify-pc__banner/.test(cl)) return true;
        e = e.parentElement || (e.getRootNode && e.getRootNode().host) || null;
      }
    }
    return false;
  }

  /* Finche' il popup di Omnisend resta acceso nell'app, se ne aprirebbero due.
     Si spegne solo quello a tutto schermo: i moduli di iscrizione messi dentro
     la pagina, per esempio nel piede, non si toccano. */
  function spegniQuelloDiOmnisend() {
    var forme = document.querySelectorAll('div[class*="omnisend-form"]');
    for (var i = 0; i < forme.length; i++) {
      var f = forme[i];
      var r = f.getBoundingClientRect();
      /* si riconosce il popup dal fatto che copre mezzo schermo e chiede una
         email: un modulo dentro la pagina, nel piede, e' alto molto meno */
      var aTuttoSchermo = r.height > window.innerHeight * 0.5
        && f.querySelector('input[type="email"], input[name="emailField"]');
      if (aTuttoSchermo) f.style.setProperty('display', 'none', 'important');
    }
  }
  spegniQuelloDiOmnisend();
  new MutationObserver(spegniQuelloDiOmnisend).observe(document.documentElement,
    {childList: true, subtree: true});

  var scatola = document.querySelector('.mnp');
  if (!scatola) return;

  /* Linguetta laterale "Un omaggio per te" (Raffaello, 15/10): resta a portata di chi
     non e' iscritto e apre il popup quando la clicchi, anche se l'aveva chiuso.
     A chi si e' iscritto non si mostra. */
  var linguetta = document.querySelector('.mnp-tab');
  function iscritto() { var s = stato(); return s.cosa === 'iscritto' && s.fino > Date.now(); }
  if (iscritto()) { if (linguetta) linguetta.remove(); return; }
  function mostraLinguetta() { if (!linguetta || iscritto()) return; if (cookieAperti()) { setTimeout(mostraLinguetta, 300); return; } linguetta.hidden = false; void linguetta.offsetWidth; linguetta.classList.add('mnp-tab--su'); }
  function nascondiLinguetta() { if (linguetta) linguetta.classList.remove('mnp-tab--su'); }
  /* Subito, senza attese: se c'e' il banner dei cookie riprova ogni 300 ms e appare appena lo si chiude */
  mostraLinguetta();
  document.addEventListener('visitorConsentCollected', function () { setTimeout(mostraLinguetta, 50); });
  setInterval(function () {
    if (!linguetta || aperto || linguetta.hidden) return;
    linguetta.classList.remove('mnp-tab--scossa');
    void linguetta.offsetWidth;
    linguetta.classList.add('mnp-tab--scossa');
  }, 15000);

  var modulo = scatola.querySelector('form');
  var campo = scatola.querySelector('.mnp__campo');
  var consenso = scatola.querySelector('.mnp__consenso input');
  var bottone = scatola.querySelector('.mnp__bottone');
  var errore = scatola.querySelector('.mnp__errore');
  var dentro = scatola.querySelector('.mnp__dentro');
  var fatto = scatola.querySelector('.mnp__fatto');
  var aperto = false;

  function apri(forza) {
    if (aperto || (!forza && (giaVisto() || cookieAperti()))) return;
    aperto = true;
    nascondiLinguetta();
    scatola.classList.add('mnp--aperto');
    scatola.removeAttribute('aria-hidden');
    setTimeout(function () { if (campo) campo.focus({preventScroll: true}); }, 320);
  }
  function chiudi() {
    aperto = false;
    scatola.classList.remove('mnp--aperto');
    scatola.setAttribute('aria-hidden', 'true');
    if (!iscritto()) { segna('chiuso', GIORNI_CHIUSO); setTimeout(mostraLinguetta, 400); }
  }
  function evento(nome) { try { if (window.clarity) window.clarity('event', nome); } catch (e) {} }
  if (linguetta) linguetta.addEventListener('click', function () { evento('nl_linguetta_click'); apri(true); });

  scatola.addEventListener('click', function (e) {
    if (e.target === scatola || e.target.closest('.mnp__chiudi')) chiudi();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && aperto) chiudi();
  });

  /* si apre dopo un po', oppure appena il mouse esce dalla pagina
     (non se l'ha chiuso da poco: allora resta solo la linguetta) */
  if (APERTURA_AUTOMATICA && !giaVisto()) var orologio = setTimeout(function cerca() {
    if (cookieAperti()) { orologio = setTimeout(cerca, 2000); return; }
    apri();
  }, ATTESA);
  document.addEventListener('mouseout', function (e) {
    if (APERTURA_AUTOMATICA && !e.relatedTarget && e.clientY <= 0 && !giaVisto()) apri();
  });

  function valida(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  if (modulo) modulo.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (campo.value || '').trim();
    errore.hidden = true;
    if (!valida(email)) {
      errore.textContent = 'Controlla l’indirizzo: manca qualcosa.';
      errore.hidden = false;
      campo.focus();
      return;
    }
    if (consenso && !consenso.checked) {
      errore.textContent = 'Serve la spunta per poterti scrivere.';
      errore.hidden = false;
      return;
    }
    bottone.disabled = true;
    bottone.textContent = 'Un attimo';

    /* Omnisend: stessa chiamata che fa il modulo dell'app */
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['identifyContact', {
        email: email,
        tags: ['popup-sito', 'da-linguetta'],
        identifiers: [{
          type: 'email',
          id: email,
          channels: {email: {status: 'subscribed', statusDate: new Date().toISOString()}}
        }]
      }]);
    } catch (err) { console.error('MONOM popup:', err); }

    segna('iscritto', GIORNI_ISCRITTO);
    evento('nl_iscrizione_linguetta');
    if (linguetta) linguetta.remove();
    setTimeout(function () {
      if (dentro) dentro.hidden = true;
      if (fatto) fatto.hidden = false;
      setTimeout(chiudi, 3200);
    }, 500);
  });
})();
